import { CaseReportExternalProps } from 'app/area/case-report/case-report-container';
import { FavouriteScreen } from 'app/area/favourite/components/favourite-screen';
import { searchTranslation } from 'app/area/favourite/constants';
import { useInstanceOptions } from 'app/area/favourite/favourite-context';
import { 
  useSavedReportState,
  useFavouriteDefinitions, 
  useActionCreators, 
  useSortOptions,
  useReport,
  useSearchQuery,
  useLoadFavouriteDefinitionEffect,
  useSearchRequiredUsers,
  useUrlMultipleSuppliers
} from 'app/area/favourite/hooks';
import { StatisticalReportExternalProps } from 'app/area/reports/types';
import { STATE } from 'app/constants';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import * as React from 'react';

interface FavouriteProps {
  embeddedFavourite?: boolean;
  editSavedFavourite?: boolean;
  initiallyOpenFilter?: boolean;
  favouriteId: number;
  overrideReport?: number;
  caseReportExternalProps?: CaseReportExternalProps;
  statisticalReportExternalProps?: StatisticalReportExternalProps;
  windowAsScrollableAncestor?: boolean;
}

export function Favourite({
  embeddedFavourite,
  editSavedFavourite,
  initiallyOpenFilter,
  favouriteId,
  overrideReport,
  caseReportExternalProps,
  statisticalReportExternalProps,
  windowAsScrollableAncestor
}: FavouriteProps) {

  const {
    hideHeader,
    hideFilters
  } = useInstanceOptions();

  const {
    definition,
    workingDefinition,
    updateDefinition,
    fetchingDefinition
  } = useFavouriteDefinitions();

  useLoadFavouriteDefinitionEffect(favouriteId, embeddedFavourite);

  const {
    searchQueryTemp,
    onChange,
    onSearch
  } = useSearchQuery();

  const {
    createReport,
    updateExistingReport,
    onCloseReport,
    onCreateReport,
    onUpdateReport
  } = useSavedReportState(editSavedFavourite);
  
  const {
    report,
    fetchingReportCategory,
    reportCategory
  } = useReport(overrideReport, !hideHeader);
  
  const {
    fetchingSortOptions,
    loadSortOptions,
    updateSortOptions,
    sortOptions
  } = useSortOptions(report);
  
  const {
    displayExportToZip,
    downloadReport,
    getMulitpleSuppliersUrl,
    getSearchRequiredUsers
  } = useActionCreators();

  const searchRequiredUsers = useSearchRequiredUsers();

  const urlMultipleSuppliers = useUrlMultipleSuppliers();
  
  const translation = useTranslation(STATE.favourite, searchTranslation);
  
  const sharedState = useSharedState();
  
  const favouriteOwnerId = definition?.validState?.owner?.v;
  const showUpdate = sharedState?.id === favouriteOwnerId;

  return <FavouriteScreen
    hideHeader={hideHeader}
    hideFilters={hideFilters}
    translation={translation}
    definition={definition}
    workingDefinition={workingDefinition}
    initiallyOpenFilter={initiallyOpenFilter}
    isCreateReportOpen={createReport}
    updateExistingReport={updateExistingReport}
    onCreateReport={onCreateReport}
    onUpdateReport={onUpdateReport}
    onCloseReport={onCloseReport}
    fetchingReportCategory={fetchingReportCategory}
    fetchingDefinition={fetchingDefinition}
    fetchingSortOptions={fetchingSortOptions}
    loadSortOptions={loadSortOptions}
    displayExportToZip={displayExportToZip}
    downloadReport={downloadReport}
    getMultipleSuppliersUrl={getMulitpleSuppliersUrl}
    urlMultipleSuppliers={urlMultipleSuppliers}
    getSearchRequiredUsers={getSearchRequiredUsers}
    searchQueryTemp={searchQueryTemp}
    onChange={onChange}
    onSearch={onSearch}
    report={report}
    reportCategory={reportCategory}
    updateDefinition={updateDefinition}
    updateSortOptions={updateSortOptions}
    sharedState={sharedState}
    sortOptions={sortOptions}
    caseReportExternalProps={caseReportExternalProps}
    statisticalReportExternalProps={statisticalReportExternalProps}
    favouriteId={favouriteId}
    showUpdate={showUpdate}
    searchRequiredUsers={searchRequiredUsers}
    windowAsScrollableAncestor={windowAsScrollableAncestor}
  />;
}
